import { Modal, useModals } from 'almanac-ui/Modal'
import { Text } from 'blaze-ui/Text/Text'
import { GoogleDriveClient } from 'api/clients/GoogleDriveClient'
import { GoogleDriveIntegration } from 'api/clients/ExternalIntegrationsClient'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { useQueryClient } from 'react-query'
import Styles from './GoogleDriveSettingsModal.module.scss'

export const GoogleDriveSettingsModal = ({ integration }: { integration: GoogleDriveIntegration }) => {
  const { closeModal } = useModals()
  const workspaceId = useCurrentWorkspaceId()
  const queryClient = useQueryClient()

  const handleFullSync = async () => {
    if (!workspaceId) return

    await GoogleDriveClient.sync({
      workspaceId,
      integrationId: integration.id,
      reset: true,
    })
    queryClient.invalidateQueries(['googleDriveSync', integration.id])
    closeModal()
  }

  return (
    <Modal.Root size="sm" aria-label="Google Drive Settings">
      <Modal.Header title="Google Drive Settings" />
      <Modal.Content>
        <div className={Styles.content}>
          <Text variant="secondary" color="var(--dark-80)">
            Run a full sync to re-import all files from your connected Google Drive folders.
          </Text>
        </div>
      </Modal.Content>
      <Modal.Footer>
        <Modal.FooterContent slot="left">
          <Modal.FooterButton variant="tertiary" size="lg" onPress={closeModal}>
            Cancel
          </Modal.FooterButton>
        </Modal.FooterContent>
        <Modal.FooterContent slot="right">
          <Modal.FooterButton variant="primary" size="lg" onPress={handleFullSync}>
            Full Sync
          </Modal.FooterButton>
        </Modal.FooterContent>
      </Modal.Footer>
    </Modal.Root>
  )
}
